/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetAutoCompleteLocationsLocation interface.
 */
export function instanceOfGetAutoCompleteLocationsLocation(value) {
    if (!('placeId' in value) || value['placeId'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    return true;
}
export function GetAutoCompleteLocationsLocationFromJSON(json) {
    return GetAutoCompleteLocationsLocationFromJSONTyped(json, false);
}
export function GetAutoCompleteLocationsLocationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'placeId': json['placeId'],
        'description': json['description'],
    };
}
export function GetAutoCompleteLocationsLocationToJSON(json) {
    return GetAutoCompleteLocationsLocationToJSONTyped(json, false);
}
export function GetAutoCompleteLocationsLocationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'placeId': value['placeId'],
        'description': value['description'],
    };
}
